import {Pipe, PipeTransform} from '@angular/core';
import {UserRepresentation} from '../../models/UserRepresentation';

@Pipe({
    name: 'userFullName'
})
export class UserFullNamePipe implements PipeTransform {

    transform(value: UserRepresentation, args?: any): any {
        return value ? `${value.firstName} ${value.lastName}` : '';
    }

}
